exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card_tpis[data-v-739aa582]{font-size:22px;border-bottom:none;position:relative;padding-left:32px}.card_tpis[data-v-739aa582]::before{content:\"\";width:12px;height:12px;border:3px solid #2687f3;border-radius:6px;display:inline-block;margin-right:10px}.round[data-v-739aa582]{display:inline-block;-ms-flex-negative:0;flex-shrink:0;width:6px;height:6px;background:#ff9f24;border-radius:50%;margin-right:10px;margin-top:7px}.ys_two_ellipsis[data-v-739aa582]{display:inline-block;text-overflow:-o-ellipsis-lastline;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical}", ""]);

// exports
